import React from 'react';
import { ShimmerCircularImage, ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";

const MediaThreeLoader = () => {
  return (
    <>
      <div className="d-flex">
          <div className="d-flex flex-grow-1">
            <ShimmerCircularImage size={40} className="flex-1 mg-b-0" />
            <div style={{ width: '130px' }}><ShimmerTitle line={2} gap={5} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
          </div>
          <div style={{ width: '100px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
        </div>
        <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
        <div className="mg-t-8 d-flex flex-wrap mx-n-4">
          <div className="pd-x-4 w-50"><ShimmerThumbnail height={295} className="rounded-3 mb-0" /></div>
          <div className='pd-x-4 w-50'>
            <div className="w-100"><ShimmerThumbnail height={145} className="rounded-3 mb-0" /></div>
            <div className="w-100"><ShimmerThumbnail height={145} className="rounded-3 mb-0" /></div>
          </div>
        </div>
        <div className="d-flex align-items-center mg-t-15">
          <div className="d-flex flex-grow-1 align-items-center">
            <ShimmerCircularImage size={40} className="flex-1 mg-b-0" />
            <div style={{ width: '48px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
          </div>
          <div style={{ width: '75px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0" /></div>
        </div>
    </>
  );
};

export default MediaThreeLoader;
